var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14,
    stroke: "#8C8C8C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14,
    stroke: "#8C8C8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2C7.60769 2 2 7.60769 2 14.5C2 21.3923 7.60769 27 14.5 27C21.3923 27 27 21.3923 27 14.5C27 7.60769 21.3923 2 14.5 2ZM21.0051 10.3103L12.9282 19.9256C12.8398 20.0313 12.7297 20.1167 12.6054 20.176C12.4811 20.2353 12.3454 20.2671 12.2077 20.2692H12.191C12.0564 20.2692 11.9232 20.2409 11.8002 20.1861C11.6772 20.1313 11.5671 20.0513 11.4769 19.9513L8.01538 16.1051C7.86224 15.9404 7.77157 15.7273 7.75913 15.5028C7.74669 15.2782 7.81324 15.0564 7.94726 14.8758C8.08127 14.6952 8.27428 14.5672 8.4928 14.514C8.71132 14.4608 8.94157 14.4858 9.14359 14.5846C9.25897 14.6423 9.36154 14.7218 9.44359 14.8179L12.1654 17.8436L19.5333 9.07436C19.7002 8.88933 19.9323 8.77629 20.1809 8.75905C20.4294 8.74181 20.675 8.82171 20.8658 8.98193C21.0565 9.14214 21.1777 9.37016 21.2037 9.61794C21.2297 9.86573 21.1585 10.1139 21.0051 10.3103Z",
    fill: "#00A03B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.26ca12f9808231647c2a3f3f9509d747.svg";
export { ForwardRef as ReactComponent };